import { lazy } from 'react';

import lazyWithPreload from 'utils/lazyPreload';

const ArchiveProgramModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/ArchiveProgramModal'
    ),
);

const ScheduleProgramSurveyModal = lazyWithPreload(
  () => import('./modals/ScheduleProgramSurveyModal'),
);

const BulkMovePlacementsModal = lazy(
  () => import('./modals/BulkMovePlacementsModal'),
);

const BulkPublishPlacementsModal = lazy(
  () => import('./modals/BulkPublishPlacementsModal'),
);

const CloneProgramModal = lazy(() => import('./modals/CloneProgramModal'));

const CreateProgramModal = lazy(() => import('./modals/CreateProgramModal'));

const ConfigGuideModal = lazy(() => import('./modals/ConfigGuideModal'));

const DeleteStageModal = lazy(() => import('./modals/DeleteStageModal'));

const PlacementViewGuideModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/PlacementViewGuideModal'
    ),
);

const UploadCustomFormModal = lazy(
  () => import('./modals/UploadCustomFormModal'),
);

const ApproveBYOPModal = lazy(() => import('./modals/ApproveBYOPModal'));

const BulkEmailModal = lazy(() => import('./modals/BulkEmailPlacementsModal'));
const OpportunitySponsorModal = lazy(
  () => import('./modals/OpportunitySponsorModal'),
);

const SyncCaseloadsModal = lazy(() => import('./modals/SyncCaseloadsModal'));
const UserPreviewDrawer = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/pages/ProgramConfig/components/SyncCandidates/components/UserPreviewDrawer'
    ),
);
const ShareProgramModal = lazy(
  () =>
    import('modules/IndustryPartnerProgramManagement/modals/ShareProgramModal'),
);

const ManageAppQuestionModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/ManageAppQuestionModal'
    ),
);

const ExportFormSequencesModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/ExportFormSequencesModal'
    ),
);

const PreviewApplicationModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/PreviewApplicationModal'
    ),
);

const ConfigureManagersDrawer = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/ConfigureManagersDrawer/containers/ConfigureManagersDrawerContainer'
    ),
);

const ExportCandidateApplicationsModal = lazy(
  () =>
    import(
      'modules/IndustryPartnerProgramManagement/modals/ExportCandidateApplicationsModal/ExportCandidateApplicationsModalContainer'
    ),
);

export default {
  APPROVE_BYOP_MODAL: ApproveBYOPModal,
  ARCHIVE_PROGRAM_MODAL: ArchiveProgramModal,
  BULK_EMAIL_PLACEMENTS_MODAL: BulkEmailModal,
  BULK_MOVE_PLACEMENTS_MODAL: BulkMovePlacementsModal,
  BULK_PUBLISH_PLACEMENTS_MODAL: BulkPublishPlacementsModal,
  CLONE_PROGRAM_MODAL: CloneProgramModal,
  CREATE_PROGRAM_MODAL: CreateProgramModal,
  CONFIG_GUIDE_MODAL: ConfigGuideModal,
  DELETE_STAGE_MODAL: DeleteStageModal,
  PLACEMENT_VIEW_GUIDE_MODAL: PlacementViewGuideModal,
  SCHEDULE_PROGRAM_SURVEY_MODAL: ScheduleProgramSurveyModal,
  SHARE_PROGRAM_MODAL: ShareProgramModal,
  SYNC_CASELOADS_MODAL: SyncCaseloadsModal,
  UPLOAD_CUSTOM_FORM_MODAL: UploadCustomFormModal,
  OPPORTUNITY_SPONSOR_MODAL: OpportunitySponsorModal,
  USER_PREVIEW_DRAWER: UserPreviewDrawer,
  MANAGE_APP_QUESTION_MODAL: ManageAppQuestionModal,
  EXPORT_FORM_SEQUENCES_MODAL: ExportFormSequencesModal,
  PREVIEW_APPLICATION_MODAL: PreviewApplicationModal,
  CONFIGURE_MANAGERS_DRAWER: ConfigureManagersDrawer,
  EXPORT_CANDIDATE_APPLICATIONS_MODAL: ExportCandidateApplicationsModal,
};
